module.exports = __webpack_public_path__ + "files/0b13353aa9a371484d5533eb592b2a00.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bold-webfont.ttf
 ** module id = 885
 ** module chunks = 0
 **/